var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',[(_vm.$vuetify.breakpoint.smAndUp)?_c('new-store-titlebar'):_vm._e(),_c('router-view'),(_vm.$vuetify.breakpoint.smAndUp)?_c('new-footer'):_vm._e(),(this.$vuetify.breakpoint.xsOnly && _vm.showBottomNav)?_c('bottom-navbar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }